import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { StaticQuery, graphql } from "gatsby"
import { Remarkable } from 'remarkable';
var md = new Remarkable();

const thematic_areas = () => (
    
  <StaticQuery query={Bluequery} render={data=>{

          
          console.log(data.video_sections.edges[0].node.frontmatter.title)

          return (  
        <div>
            <Layout>
                <SEO title="Blue Economy" />            
            
            <section class="hero p-0 odd">
            <div class="swiper-container full-slider slider-h-100 slider-h-auto">
                <div class="swiper-wrapper">

                    
                    <div class="swiper-slide slide-center">

                    <video loop autoPlay class="full-image" data-mask="40">
                            <source src={data.video_sections.edges[0].node.frontmatter.video} type="video/mp4"/>
                    </video>
                       
                        <div class="slide-content row">
                            <div class="col-12 d-flex justify-content-start justify-content-md-center inner">
                                <div class="center text-left text-md-center">

                                 
                                    <h2 >{data.video_sections.edges[0].node.frontmatter.title}</h2>
                                    <div dangerouslySetInnerHTML={{__html:md.render(data.video_sections.edges[0].node.frontmatter.description)}}></div>
                                  
                                  
                                </div>
                            </div>
                        </div>
                    </div>

                   


                </div>
                <div class="swiper-pagination"></div>
            </div>
        </section>


        <section id="about" class="section-1 highlights team image-right" style={{padding:"50px 0"}}>
        
          <div class="container">
            {data.list_section.edges.map((tag,index) => (
              <div>
                <div class="row">
                    <div class="col-12 col-lg-8 align-self-top text" style={{textAlign:"center"}}>
                        <div class="row intro m-0">
                            <div class="col-12 p-0">
                                
                                <h2>{tag.node.frontmatter.title}</h2>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 p-0 pr-md-5" style={{textAlign:"justify"}}>
                            <div dangerouslySetInnerHTML={{__html:md.render(tag.node.frontmatter.description)}}></div>
                               {/* <p>{tag.node.frontmatter.description}</p> */}
                            </div>
                        </div>
                    </div>
                    <div  class="col-12 col-lg-4" style={{width:"100%" , height:"100%" ,marginTop:'5%'}}>
                              
                                <img src={tag.node.frontmatter.image} class="fit-image" />    
                    </div>
                </div>
                <br></br><br></br><br></br>
                </div>
                ))}
            </div>
           
        
          
        </section>
        </Layout>
            </div>
        )
      }}/>
)

  const Bluequery = graphql`
  {
    video_sections: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/blueeconomy/video_section/"}}
    )  {
      edges {
        node {
          id
          frontmatter {
            
            title
            description
            video
        
          }
          
          excerpt
        }
      }
    }
    
    
    list_section: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/blueeconomy/list_section/"}}
    )  {
      edges {
        node {
          id
          frontmatter {
            
            title
            description
            image
          }
    
          excerpt
        }
      }
    }


  }

 `



  
export default thematic_areas